import React, { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { LinkButton } from '../../App/Components/ButtonWithText/style'

import { IProps } from './IProps'
import {
  CardData,
  InnerCardContainer,
  OuterCardContainer,
  StyledText,
  StyledTitle,
} from './style'
import { useHistory, useParams } from '../../Router'

export const WorkshopCard: React.FunctionComponent<IProps> = ({
  workshop,
  fontColor,
  highlightColor,
  backgroundColor,
}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { establishmentId } = useParams<{ [key: string]: string }>()

  const duration = workshop.endsAt.diff(workshop.startsAt, 'minutes')

  /*
   * OB-506: absolute path so the URL is portable when copied via
   * right-click "Copy Link Address" / long-press "Copy link".
   */
  const bookUrl = `/${establishmentId}/workshops/${workshop.uuid}/book`

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.altKey ||
      e.ctrlKey ||
      e.shiftKey
    ) {
      return
    }
    e.preventDefault()
    history.push(bookUrl)
  }

  return (
    <OuterCardContainer backgroundcolor={highlightColor}>
      <InnerCardContainer>
        <CardData>
          <StyledTitle fontcolor={fontColor}>{workshop.title}</StyledTitle>
          {!workshop.description || (
            <StyledText fontcolor={fontColor}>{workshop.description}</StyledText>
          )}
          <StyledText fontcolor={fontColor}>
            {workshop.startsAt.format('dddd, D MMM YYYY')} {t('at')}{' '}
            {workshop.startsAt.format('LT')}
          </StyledText>
          <StyledText fontcolor={fontColor}>
            {t(
              duration >= 120
                ? '{{hours}} hours and {{mins}} minutes'
                : duration >= 60
                ? '{{hours}} hours and {{mins}} minutes_one'
                : '{{amount}} minutes',
              {
                count: Math.floor(duration / 60),
                amount: duration,
                hours: Math.floor(duration / 60),
                mins: Math.floor(duration % 60),
              }
            )}
          </StyledText>
        </CardData>
        <LinkButton
          href={bookUrl}
          onClick={handleClick}
          backgroundcolor={backgroundColor}
          fontcolor={highlightColor}
        >
          {t('Book')}
        </LinkButton>
      </InnerCardContainer>
    </OuterCardContainer>
  )
}
